'use client'

import { createContext, useContext } from 'react'

interface PopupOrderContextValue {
  onOrderExecuted: () => void
}

export const PopupOrderContext = createContext<PopupOrderContextValue | null>(null)

export function usePopupOrderContext() {
  return useContext(PopupOrderContext)
}
